import React from "react";
import Product from "./component/Product/Product";

const Home = () => {
  return (
    <>
      <Product />
    </>
  );
};

export default Home;
